




import Vue from "vue";
import { Component, Prop, Provide } from "vue-property-decorator";
import L, { LatLng, latLngBounds } from "leaflet";
import * as esri from "esri-leaflet";
import MapConfig from "../mapConfig.model";
import {
  MapLayer,
  TableData
} from "../types";
import { Feature } from "geojson";
import FeatureLayerData from "../featureLayerData.model";
//import Cluster from 'esri-leaflet-cluster';
//import { GeoJsonProperties } from "geojson";

@Component({})
export default class MapFeatureLayer extends Vue {
  featureLayer: any;
  @Prop() mapConfig!: MapConfig;
  @Prop() layers!: MapLayer;
  @Prop() map!: L.Map;
  showLabel: boolean = true;

  mounted() {
    let template = "";
    let mapData: any = [];
    let tableData: TableData = { items: [], fields: [], sortBy: "" };
    let vm = this;

    if (this.layers.tableFields) {
      tableData.fields = this.layers.tableFields;
    }

    let icons = {
      default: L.icon({
        iconUrl:
          "https://webtempo.cityofboise.org/assets/img/_layout/map-marker--yellow.svg"
      })
    };

    if (this.layers ) {
     // myMap.createPane(this.layers.name);
      var myWhereClause = vm.layers.whereClauseField
        ? vm.layers.whereClauseField.replace(/%27/g, "'")
        : "1=1"; //get all features
      vm.featureLayer = esri.featureLayer({
        url: this.layers.url + '?resultType=none',//fix for on-premise features - esri-leaflet defaults to 'tile' which causes errors
        where: myWhereClause,
        useCors: false,
        cacheLayers: false,
        isModern:false,       
        onEachFeature: function(feature: GeoJSON.Feature, layer: any) {
          //if data and show table, then process
          if (
            mapData &&
            feature &&
            feature.properties &&
            vm.layers.includeTable
          ) {
            if (tableData.fields.length == 0) {
              for (const key of Reflect.ownKeys(feature.properties)) {
                if (!key.toString().startsWith("Shape") && key != "OBJECTID") {
                  let properties = { key: key.toString(), sortable: true };
                  tableData.fields.push(properties);
                }
              }
            }
            tableData.sortBy = tableData.fields[0].key;
            tableData.items.push(feature.properties);
          }
         
        },
        // pointToLayer: function(geojson: GeoJSON.Feature, latlng: L.LatLngExpression)  {
        //   // eslint-disable-next-line
        //    console.log(geojson);
        //     // eslint-disable-next-line
        //    console.log(geojson.geometry.type);
        //   if(latlng && latlng instanceof L.LatLng && geojson && geojson.geometry && geojson.geometry.type &&geojson.geometry.type =='Point'){
        //     return  L.marker(latlng, {
        //       icon: icons.default
        //     });
        //   }
          
        // },
        style: function() {
          if (vm.layers.style) {
            return vm.layers.style;
          }
        }
      });
      //if a popup template exists, bind template to the popup
      if (this.layers.template && this.layers.template != "") {
        template = this.layers.template;
        vm.featureLayer.bindPopup(function(evt: any) {
          if (
            evt.feature &&
            evt.feature.geometry &&
            evt.feature.geometry.type &&
            evt.feature.geometry.type != "Point"
          ) {
            vm.featureLayer.resetStyle(evt.feature.id);
            vm.featureLayer.setFeatureStyle(evt.feature.id, {
              color: "#F5A623",
              weight: 3,
              opacity: 1
            });
          }

          return L.Util.template(template, evt.feature.properties);
        });
      }
    
    let featureLayerData = new FeatureLayerData();
    featureLayerData.featureLayer = vm.featureLayer;
    featureLayerData.tableData = tableData;
       vm.$emit("featureReady", featureLayerData);
   
      
    }
  }
  beforeDestroy() {
    if (this.featureLayer) {
      this.map.removeLayer(this.featureLayer);
    }
  }
}
